export default "__VITE_ASSET__Cy9aHHgf__"